/* eslint-disable */
export const getContent = ({ siteName }) => {
  const CRL8_SITENAME = siteName;

  return new Promise((resolve) => {
    (function () {
      let crl8 = (window.crl8 = window.crl8 || {});
      let isReady = false;
      let readyCallbacks = [];

      crl8.ready = function (callback) {
        if (isReady) {
          callback();
        } else {
          readyCallbacks.push(callback);
        }
      };

      crl8.pixel = crl8.pixel || function () {
        crl8.pixel.q.push(arguments);
      };
      crl8.pixel.q = crl8.pixel.q || [];

      let document = window.document;
      let scriptElement = document.createElement('script');
      let scriptType = crl8.debug || document.location.search.includes('crl8-debug=true') ? 'js' : 'min.js';

      scriptElement.async = true;
      scriptElement.src = `${document.location.protocol}//edge.curalate.com/sites/${CRL8_SITENAME}/site/latest/site.${scriptType}`;

      scriptElement.onload = function () {
        isReady = true;
        readyCallbacks.forEach((callback) => callback());
        resolve({ status: 'LOADED', siteName: CRL8_SITENAME });
      };

      scriptElement.onerror = function () {
        resolve({ status: 'ERROR', siteName: CRL8_SITENAME });
      };

      try {
        let firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode.insertBefore(scriptElement, firstScript.nextSibling);
      } catch (error) {
        resolve({ status: 'ERROR', siteName: CRL8_SITENAME });
      }
    })();
  });
};
/* eslint-enable */